import type { LatLngBounds } from 'leaflet';

import { createGenericFetchMachine } from '@/common/overmind/machines/generic-fetch-machine';
import type { MapImage } from '@/overmind/effects/adapters/baseadapter';

import * as actions from './actions';

const state = createGenericFetchMachine<MapImage, LatLngBounds>();

export { state, actions };
